/** ----------------------------------------
    Interface
 ---------------------------------------- */

import { NotificationStore } from '@interface/store/Notification';
import { StoreHelper } from '@fruitpackage/helpers';
import resetState from './state';

/** ----------------------------------------
    Mutations
---------------------------------------- */

let baseMutations = { 
    setNotifications(state: NotificationStore, data: any) {
        state.unread = {};
        data.unread.forEach(notification => {
            state.unread[notification.id] = notification;
        });

        state.read = {};
        data.read.forEach(notification => {
            state.read[notification.id] = notification;
        });
    },

    setAllRead(state: NotificationStore) {
        state.read = {...state.read, ...state.unread};
        state.unread = {};
    },

    setRead(state: NotificationStore, id: id) {
        state.read[id] = state.unread[id];
        delete state.unread[id];
        state.read = {...state.read };
        state.unread = {...state.unread };
    },

    clearState(state: NotificationStore) {
        state = resetState();
    }
};

const mutations = { 
    ...baseMutations, 
    ...StoreHelper.resetStateMutation(resetState)
}

/** ----------------------------------------
    Export Mutations
---------------------------------------- */

export default mutations;